import React from "react";
import "../../styles/SharedStates.css";

export default function AdminPageHeader({ icon: Icon, title, description, actions, className = "" }) {
  return (
    <header className={`admin-page-header ${className}`.trim()}>
      <div className="admin-page-header__copy">
        <div className="admin-page-header__title-row">
          {Icon && <Icon className="admin-page-header__icon" aria-hidden="true" />}
          <h1>{title}</h1>
        </div>
        {description && <p>{description}</p>}
      </div>
      {actions && <div className="admin-page-header__actions">{actions}</div>}
    </header>
  );
}
